import type React from 'react';

import { DeleteVariantIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import st from './DeleteFacesConfirmation.module.sass';

interface DeleteFacesConfirmationProps extends WithDataTestid {
  onConfirm: VoidFunction;
  onReject: VoidFunction;
}

function DeleteFacesConfirmation({
  onConfirm,
  onReject,
  'data-testid': dataTestId = undefined,
}: DeleteFacesConfirmationProps): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      className={st.DeleteFacesConfirmation}
      data-testid={dataTestId}
    >
      <div className={st.Header}>
        <DeleteVariantIcon className={st.Icon} />
        <div className={st.Description}>
          <span className={st.Title}>{t('monokit:delete faces.confirmation.title')}</span>
          <span className={st.Subtitle}>{t('monokit:delete faces.confirmation.subtitle')}</span>
        </div>
      </div>

      <div className={st.Actions}>
        <Control.Button
          className={st.Action}
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {t('monokit:delete faces.buttons.cancel')}
        </Control.Button>
        <Control.Button
          className={st.Action}
          kind="negative"
          onClick={onConfirm}
          variant="filled"
        >
          {t('monokit:delete faces.buttons.delete')}
        </Control.Button>
      </div>
    </div>
  );
}

export { DeleteFacesConfirmation };
